import FormSearchFilter from "../../components/FormSearchFilter";
import React, {useEffect, useState} from "react";
import {getBetGames, getGamesByType, getTableGames} from "../../constant";
import {Button, Input, notification} from "antd";
import APIService from "../../service/APIService";

export default function ConfigBankNewPage() {
  const [data, setData] = useState({});

  async function getConfigPaymentInfo() {
    try {
      const data = await APIService.configPaymentInfo();
      if (data) {
        console.log(data);
        setData(data);
      }
    } catch (error) {
      console.error(error);
    }
  }

  async function updateConfigPaymentInfo(type, config) {
    try {
      const data = await APIService.updateConfigPaymentInfo(type, config);
      if (data) {
        console.log(data);
        notification["success"]({
          message: "Thành công",
          description: `${type} đã được cập nhật.`,
        });
      }
    } catch (error) {
      console.error(error);
    }
  }

  useEffect(() => {
    getConfigPaymentInfo().then();
  }, []);

  return <>
    <FormSearchFilter title="Quỹ Bank"></FormSearchFilter>

    <div className="items-center m-8 flex-1.2 grid grid-flow-row-dense grid-cols-8 gap-8">
      {getBetGames().map(i => {
        const field = (i.codeBank || i.code) + "_GAME_BANK";
        const value = data[field];
        if (value === undefined) {
          return null;
        }
        return <>
          <div className="col-span-2">
            <p className="text-base font-medium text-sm">{i.name}</p>
          </div>
          <div className="col-span-5">
            <Input
              value={value}
              onChange={(text) => {
                setData({
                  ...data,
                  [field]: text.target.value,
                });
              }}
            />
          </div>
          <div className="col-span-1">
            <Button
              type="primary"
              onClick={() => {
                updateConfigPaymentInfo(
                  field,
                  data[field]
                ).then();
              }}
            >
              Update
            </Button>
          </div>
        </>
      })}
    </div>
  </>
}
